import { z as zod } from 'zod';

import { BaseDatastreamDtoSchema } from '@enterprise/types';

/**
 * Zod schema for validating a comment object in the datastream system.
 *
 * Extends the `BaseDatastreamDtoSchema` with additional fields specific to comments:
 * - `comment`: The text content of the comment (required).
 * - `entryUser`: The ID of the user who entered the comment (optional).
 * - `parentId`: The ID of the parent comment, if this is a reply (optional).
 * - `postedBy`: The username or identifier of the poster (optional).
 */
export const CommentSchema = BaseDatastreamDtoSchema.extend({
  comment: zod.string(),
  entryUser: zod.number().optional(),
  parentId: zod.number().optional(),
  postedBy: zod.string().optional(),
});
